import { ErrorPageType } from '@app/enums/error-page-type';

/** sorted alphabetically **/
export const PAGE_ROUTE = {
    AccountManagement: 'accountmanager',
    Callback: 'callback',
    Client: 'client',
    ClientManagement: 'clientmanagement',
    ClientSelfOnBoarding: 'clientselfonboarding',
    ClientUsers: 'clientusers',
    DashBoard: 'dashboard',
    Eforms: 'eforms',
    Error: 'error',
    ETRF: 'etrf',
    Home: 'home',
    Inspection: 'inspection',
    InspectionAnalytics: 'inspectionanalytics',
    InspectionSummary: 'inspectionsummary',
    Login: 'login',
    Main: 'rcp',
    MainPublic: 'retail-consumer-products',
    NextGenValidateUser: 'validate-user',
    SuperAdmin: 'admin',
    TermsOfUse: 'termsofuse',
    Testing: 'testing',
    TestingSummary: 'testingsummary',
    TestingSummaryDashBoard: 'testingsummarydashboard',
    TestSummary: 'testsummary',
    UserManagement: 'usermanagement',
    VendorSupplier: 'vendorsuppliers',
    VendorSupplierSelfOnboarding: 'vendorsupplieronboarding',
};

export const PAGE_MAP = {
    main: {
        callback: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Callback}`,
        clientManagement: {
            clientUsers: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.ClientManagement}/${PAGE_ROUTE.ClientUsers}`,
            default: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.ClientManagement}`,
            vendorSupplier: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.ClientManagement}/${PAGE_ROUTE.VendorSupplier}`,
        },
        dashboard: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.DashBoard}`,
        error: {
            default: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Error}`,
            notFound: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Error}/${ErrorPageType.NotFound}`,
            unauthorized: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Error}/${ErrorPageType.Unauthorized}`,
        },
        etrf: {
            default: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.ETRF}`,
            summary: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.ETRF}/${PAGE_ROUTE.TestSummary}`,
        },
        home: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Home}`,
        inspection: {
            analytics: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Inspection}/${PAGE_ROUTE.InspectionAnalytics}`,
            default: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Inspection}`,
            summary: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Inspection}/${PAGE_ROUTE.InspectionSummary}`,
        },
        termsOfUse: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.TermsOfUse}`,
        userManagement: {
            client: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.UserManagement}/${PAGE_ROUTE.Client}`,
            default: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.UserManagement}`,
            superAdmin: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.UserManagement}/${PAGE_ROUTE.SuperAdmin}`,
        },
        testing: {
            default: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Testing}`,
            summary: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Testing}/${PAGE_ROUTE.TestingSummary}`,
            summaryDashboard: `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Testing}/${PAGE_ROUTE.TestingSummaryDashBoard}`,
        },
    },
    public: {
        error: {
            notFound: `${PAGE_ROUTE.MainPublic}/${PAGE_ROUTE.Error}/${ErrorPageType.NotFound}`,
        },
    },
    termsOfUse: PAGE_ROUTE.TermsOfUse,
};
